// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.FiltersFooter.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * FilterItem component
 */

import React from 'react';
import connect from 'share/enhancers/Izenda.Connect';
import { FIELDS as fieldsConstants } from 'logic/data/Izenda.ReportDesignerConstants';

import Validator from 'share/components/hoc/Izenda.Validator';
import Input from 'share/components/controls/Izenda.Input';
import commonMessages from 'share/messages/Izenda.CommonMessages';
import { isEmpty } from 'lodash/fp';
const ValidatorInput = Validator()(Input);

export default connect()(function FiltersFooter(props: Object) {
  const store = props.store || {};
  const reportFilters = store.reportFilters || {};
  const valManager = props.validation;

  const onChangeLogic = (e: any) => {
    reportFilters.setLogic(e.target.value);
  };

  const onValidateSyntax = () => {
    const alertDetails = store.getAlertDetail();

    alertDetails.reset(false);

    valManager.reset('filterLogic');
    return store.validateFilterSyntax().then(saveErrors => {
      if (!isEmpty(saveErrors)) {
        if (saveErrors === fieldsConstants.M24) {
          return props
            .confirmFn('Information', {
              type: commonMessages.MESSAGE_TYPE.INFO_ACCEPT,
              description: fieldsConstants.M24,
              showCancel: false
            })
            .then(() => {
              return props
                .confirmFn('Information', {
                  type: commonMessages.MESSAGE_TYPE.INFO_ACCEPT,
                  description: fieldsConstants.M25,
                  showCancel: false
                })
                .then(() => reportFilters.setLogic(''));
            });
        } else {
          valManager.updateErrors(saveErrors);
        }
      } else {
        alertDetails.set({ message: fieldsConstants.VALID_FILTER_LOGIC_MESSAGE, success: true });
      }
      return null;
    });
  };

  return (
    <div className='u_table'>
      <span className='u_tableCell control-label'>{fieldsConstants.FILTER_LOGIC_LABEL}</span>
      <div className='u_tableCell u_fullWidth'>
        <ValidatorInput
          value={reportFilters.logic}
          placeholder={fieldsConstants.FILTER_LOGIC_PLACEHOLDER}
          onChange={onChangeLogic}
          className='form-control u_inlineBlock'
          containerClassName=''
          validations={{}}
          maxLength='2000'
          field='filterLogic'
        />
      </div>
      <button className='btn btn-primary btn-report-default u_tableCell u_marginLeft' onClick={onValidateSyntax}>
        {fieldsConstants.VALIDATE_SYNTAX_LABEL}
      </button>
    </div>
  );
});



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/Filter/Izenda.FiltersFooter.js